<template>
  <div class="content">
    <div class="complete-message">
      <p>ご発注ありがとうございました。</p>
    </div>
  </div>
</template>
<script>
import Mixin from '../mixin/Mixin'
import Store from '@/store/index.js'
export default {
  name: 'Complete',
  components: {},
  mixins: [Mixin],
  methods: {},
  created() {
    Store.commit('vehicle/destroy') // 車両リストを初期化
    Store.commit('order/destroyOrder') // 車両リストを初期化
  },
  mounted() {
    this.setAppCss()
  },
}
</script>

<style lang="sass" scoped>
.complete-message
  text-align: center
  padding-top: 100px
  margin: 50px
  font-size: 24px
  font-weight: bold
</style>



// WEBPACK FOOTER //
// src/components/order/Complete.vue